/**
 * List Schema of RequestSsw
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {RequestSsw} from '@/model/resource/RequestSsw'

/* TODO: review generated schema */
export class ListRequestSswSchema extends Schema {
  readonly name = 'ListRequestSsw'

  readonly fieldSet: FieldSet<RequestSsw> = {
    idRequestPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    notaFiscal: (): FieldComponent => ({
      is: Component.Render,
    }),
    json: (): FieldComponent => ({
      is: Component.Render,
    }),
  }
}
